
import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';
import { EntityEspeciesCertificables } from './entity-especies-certificables.model';

export const EntityEspeciesCertificablesAdapter: EntityAdapter<EntityEspeciesCertificables> = createEntityAdapter<EntityEspeciesCertificables>({
  selectId: (model) => model.id,
  sortComparer: (a: EntityEspeciesCertificables, b: EntityEspeciesCertificables): number => b.id.toString().localeCompare(a.id.toString())
});

export interface EntityEspeciesCertificablesState extends EntityState<EntityEspeciesCertificables> {
  isLoading?: boolean;
  hasAddedSuccess?: boolean;
  error?: Error | null | any;
}

export const initialState: EntityEspeciesCertificablesState = EntityEspeciesCertificablesAdapter.getInitialState({
  isLoading: false,
  hasAddedSuccess: false,
  error: null
});
